import { isMobileUA } from 'dpl/shared/utils';

export const EVENT_CATEGORIES = {
  ASK_BREEDER_QUESTION: 'Ask Breeder Question',
  APPLY_TO_BREEDER: 'Apply to Breeder',
  ADVANCE_APPLICATION_STEP: 'Advance Application Step',
  SUBMIT_APPLICATION: 'Submit an Application',
  SEND_MESSAGE: 'Send a Message',
  BREEDER_SIGNUP: 'Breeder Signup',
  BREEDER_OPEN_SIGNUP_MODAL: 'Breeder Open Signup Modal',
  BREEDER_SUBMIT_APPLICATION: 'Breeder Submit Application',
  FILTER_TRANSPORTATION: 'filter_transportation',
  FILTER_LOCATION: 'filter_location',
  FILTER_AVAILABILITY: 'filter_availability',
  FILTER_HEALTH_TESTING: 'filter_health_testing',
  BREEDER_REQUEST_PAYMENT: 'breeder_payment_request',
  FOLLOW_BREED: 'follow_breed',
  MESSAGE_CTA: 'Message CTA',
  PAYMENT_TAB_CTA: 'Payment Tab CTA',
  OVERVIEW_CTA: 'Overview CTA',
  WAITLIST_CTA: 'Waitlist CTA',
  APPLICATION_CTA: 'Application CTA',
  GENERAL_SELECT_CONTACT: 'general-select_contact',
  GENERAL_ENTER_AMOUNT: 'general-enter_amount',
  GENERAL_REQUEST: 'general-request',
  PUPPY_SELECT_LITTER: 'puppy-select_litter',
  PUPPY_SELECT_PUPPY: 'puppy-select_puppy',
  PUPPY_DETAILS: 'puppy-details',
  PUPPY_REQUEST: 'puppy-request',
  BUYER_AMOUNT: 'buyer-amount',
  BUYER_ADDRESS: 'buyer-address',
  BUYER_PAYNOW: 'buyer-paynow'
};

export const EVENT_ACTION_IDS = {
  ASK_BREEDER_QUESTION: 'AW-810213694/sEF2CKL54JMBEL7Cq4ID',
  APPLY_TO_BREEDER: 'AW-810213694/T9FjCNz82ZMBEL7Cq4ID',
  SUBMIT_APPLICATION: 'AW-810213694/luBRCN6s5ZUBEL7Cq4ID',
  BREEDER_SUBMIT_APPLICATION: 'AW-667038394/21vuCPqDzsMBELrliL4C',
  SEND_MESSAGE: 'AW-810213694/itt1CM_c2JUBEL7Cq4ID'
};

/**
 * DEPRECATED: use EVENT_CATEGORIES above instead
 */
export const FACEBOOK_EVENTS = {
  SUBMIT_APPLICATION: 'SubmitApplication'
};

export const ANALYTICS_PROVIDERS = {
  GA: 'Google',
  FB: 'Facebook',
  BING: 'Bing',
  AHOY: 'Ahoy'
};

export const AHOY_URLS = {
  visits: '/user_interactions/visits',
  events: '/user_interactions/events'
};

export const SEGMENT_EVENTS = {
  BUTTON_CLICKED: 'Button Clicked',
  BUYER_APPLICATION_QUESTION_VIEWED: 'Buyer Application Question Viewed',
  BANK_ACCOUNT_AUTHORIZED: 'Bank Account Authorized'
};

export const SEGMENT_USER_JOURNEYS = {
  SCREENING_QUIZ: 'Screening Quiz',
  PAYMENTS: 'Payments',
  PAYMENTS_BIP: 'Payments (BIP)',
  PAYMENTS_REQUEST_BUYER: 'Payments (Request - Buyer)',
  JOIN_AS_BREEDER: 'Join as Breeder'
};

export const SEGMENT_PLATFORM = isMobileUA() ? 'mobile_web' : 'web';
